export default {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  minHeight: ({ windowHeight }) => windowHeight,
};
